export default __webpack_public_path__ + "0a36535a0ce05a73570b848d54695614.png";